import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import {
  getFTTBServiceAdditionalInformation,
  getFTTBServiceAntivirusInfo,
  getFTTBServiceIsChecked,
  getFTTBServiceIsDisabled,
  getFTTBServiceIsLoading,
  getFTTBServiceMultiConvergenceAdditionalInformation,
  getFTTBServicePrice,
  getFTTBServiceShortDescription,
  getFTTBServiceTitle,
} from 'pages/Internet/store/selectors';
import { setConnectAdditionalService } from 'pages/Internet/store/actions';
import { getPricePeriod } from 'pages/Home/selectors';
import {
  ServiceAdditional,
  ServiceCard,
  ServiceParams,
  ServicePrice,
  ServiceSwitch,
  ServiceTitle,
} from '../../components';

export const ServiceCardConnected = compose(
  connect((state) => ({
    shouldRender: !!getFTTBServiceTitle(state),
  })),
  withRenderFlag,
)(ServiceCard);

ServiceCardConnected.Title = connect(
  (state) => ({
    title: getFTTBServiceTitle(state),
    description: getFTTBServiceShortDescription(state),
  }),
)(ServiceTitle);

ServiceCardConnected.Switch = connect(
  (state) => ({
    checked: getFTTBServiceIsChecked(state),
    isLoading: getFTTBServiceIsLoading(state),
    disabled: getFTTBServiceIsDisabled(state),
  }),
  {
    onChange: setConnectAdditionalService,
  },
)(ServiceSwitch);

ServiceCardConnected.Params = compose(
  connect(
    (state) => ({
      activationCode: getFTTBServiceAntivirusInfo(state).activationCode,
      mobileRegion: getFTTBServiceMultiConvergenceAdditionalInformation(state).mobileRegion,
      internetRegion: getFTTBServiceMultiConvergenceAdditionalInformation(state).internetRegion,
      login: getFTTBServiceAntivirusInfo(state).login,
      password: getFTTBServiceAntivirusInfo(state).password,
      installUrl: getFTTBServiceAntivirusInfo(state).downloadUrl,
      manualUrl: getFTTBServiceAntivirusInfo(state).manualUrl,
      downloadUrls: getFTTBServiceAntivirusInfo(state).downloadUrls,
      shouldRender: getFTTBServiceIsChecked(state),
    }),
  ),
  withRenderFlag,
)(ServiceParams);

ServiceCardConnected.Additional = connect(
  (state) => ({
    children: getFTTBServiceAdditionalInformation(state),
  }),
)(ServiceAdditional);

ServiceCardConnected.Price = connect(
  (state) => ({
    price: getFTTBServicePrice(state),
    pricePeriod: getPricePeriod(state),
  }),
)(ServicePrice);
